import "./Shop.module.css";
import TheEssenceHeader from "@/reusable_sections/Header";
import ShopTitle from "./sections/ShopTitle";
import ShopContent from "./sections/ShopContent";
import TheBoutiqueFooter from "@/reusable_sections/Footer";
export default function ShopPage() {
  return <div>
      <TheEssenceHeader />
      <ShopTitle />
      <ShopContent />
      <TheBoutiqueFooter />
    </div>;
}